'use client';

import type { FC, PropsWithChildren } from 'react';

import { ArkProvider } from '@sola/ark-core/contexts/ark.tsx';
import { CartDrawerProvider } from '@sola/ark-skippy/contexts/cart-drawer.tsx';
import { AuthProvider } from '@sola/auth-sdk/components/auth-provider.tsx';
import { Sites, getPublicConfig } from '@sola/config/lib/getters.ts';
import { SupporterProvider } from '@sola/supporter-sdk/provider.tsx';

export const SkippyProviders: FC<
  PropsWithChildren<{
    locale?: string;
  }>
> = ({ children, locale }) => {
  const publicConfig = getPublicConfig();
  const includeAuthProvider =
    publicConfig.NEXT_PUBLIC_SITE_ID !== Sites.enum.compex;

  const content = (
    <ArkProvider locale={locale} loadRandomChild>
      <CartDrawerProvider>{children}</CartDrawerProvider>
    </ArkProvider>
  );

  return includeAuthProvider ? (
    <AuthProvider>
      <SupporterProvider>{content}</SupporterProvider>
    </AuthProvider>
  ) : (
    content
  );
};
